import useAIConfigs from "@/hooks/useAIConfigs";
import IconArrowBack1 from "@/icons/IconArrowBack1";
import IconArrowBack2 from "@/icons/IconArrowBack2";
import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { AIConfiguration } from "../Messaging/Bots/types";
import { LoadingSpinner } from "@velaro/velaro-component-lib";
import { set } from "lodash";

interface Props {
  title: string;
  subTitle?: string;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
  backLink?: string;
}

export default function StickyRouteHeader(props: Props) {
  const { id } = useParams();
  const { aiConfigurations, loading } = useAIConfigs();
  const [config, setConfig] = React.useState<AIConfiguration>();


  React.useEffect(() => {
    if (aiConfigurations.length > 0 && id) {
      const config = aiConfigurations.find(
        (config) => config.id === parseInt(id)
      );
      if (config) {
        setConfig(config);
        return;
      }
    }
    setConfig(undefined);
  }, [aiConfigurations, id]);

  if (loading && id && !isNaN(parseInt(id))) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <div className="top-0 sticky z-50 bg-slate-gray-50">
        <div className="relative">
          <div
            className="absolute -top-6 left-0 right-0 h-6 bg-slate-gray-50"
            aria-hidden="true"
          />
          <div className="flex items-center justify-between pb-4">
            <div className="text-lg font-medium text-slate-800 flex flex-row">
              {props.backLink && (
                <span className="mr-2">
                  <Link to={props.backLink}>
                    <IconArrowBack2 />
                  </Link>
                </span>
              )}
              <div className="flex flex-col">
                <span>{config?.name || props.title}</span>
                <span className="text-sm font-normal text-gray-500">
                  {props.subTitle}
                </span>
              </div>
            </div>
            {props.headerActions && <span>{props.headerActions}</span>}
          </div>
        </div>
        <div className="h-4 bg-slate-gray-50" aria-hidden="true" />
      </div>
      {props.children}
    </>
  );
}
